<template>
  <div class="findPassword">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!--<div class="setNavBg">-->
      <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>找回密码</h3></div>
    <div class="registerStepCon">
      <el-steps :active="1" align-center>
        <el-step title="1 基本信息"></el-step>
        <el-step title="2 验证身份"></el-step>
        <el-step title="3 重置密码"></el-step>
        <el-step title="4 操作完成"></el-step>
      </el-steps>
      <div class="baseInforConCon">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
          <el-form-item label="验证邮箱" prop="email">
            <!-- <el-input v-model="baseForm.email"></el-input> -->
            {{baseForm.email}}
          </el-form-item>
          <el-form-item label="验证码" prop="yzm" class="verifyCon">
            <el-input v-model="baseForm.yzm" class="pull-left" ></el-input>
            <el-button :disabled="disabledBtn" plain @click="findVerifyCode()">{{verifyBtn}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button @click="goToHref('/resetPassword')">下一步</el-button>
    </div>
    
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  import Cookies from 'js-cookie'
  export default {
    props: [],
    data () {
      return {
        checkFlag:false,
        sendEmailFlag:false,
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        webConfigInfo: {},
        checkList:[],
        navTitle:'找回密码',
        verifyBtn:'获取验证码',
        disabledBtn:false,
        abroadShow:false,
        currentUserId:'',
        baseForm: {
          email: '',
          yzm: ''
        },
        rules: {
          yzm: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        },
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer
    },
    created () {
      let query = this.$route.query;
      this.baseForm.email = query.email;
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      goToHref(val){
        this.$refs['baseForm'].validate((valid) => {
          if (valid) {
            if(this.baseForm.email!='' && !this.sendEmailFlag){
              this.$message({
                  message: '请点击"获取验证码"后，再填写邮箱验证码',
                  type: 'error'
              });
              return false;
            }else{
              if(this.baseForm.email !='' && this.baseForm.yzm!=''){
                this.$axios.post('/onelink.mdata.main.api/email/checkVerifyCodeExt?email='+this.baseForm.email+"&code="+this.baseForm.yzm+"&action=changePassword_", {
                }).then((res) => {
                  this.data = res.data;
                  let operateFlag = this.data.data;
                  if(!operateFlag){        
                    if(null != Cookies.get('emailCodeFailNumber_changePassword_'+this.baseForm.email.split("@")[0])){
                      this.errorCodeFailNumber = Number(Cookies.get('emailCodeFailNumber_changePassword_'+this.baseForm.email.split("@")[0]));
                    }else{
                      this.errorCodeFailNumber = 0;
                    }
                    //错误次数大于3次，删除cookie
                    if(this.errorCodeFailNumber > 3){
                      this.$message({
                        message: '邮箱验证码输入错误超过3次已失效,请重新获取验证码',
                        type: 'error'
                      });
                    }else{
                      this.$message({
                        message: '邮箱验证码输入错误',
                        type: 'error'
                      });
                    }
                    this.checkFlag = false;
                  }else{
                    this.$router.push({path: val,query:{userId:this.currentUserId,email:this.baseForm.email,verifyCode:this.baseForm.yzm}})
                    this.checkFlag = true;
                  }
                }).catch((err) => {
                  console.log(err)
                })
              }
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },
      getVerify(){
        let time=60
        clearInterval(myInterval)
        let myInterval = setInterval(()=>{
              this.verifyBtn=time+"秒后重新获取";
              time--;
              if(time<0){
                clearInterval(myInterval)
                this.verifyBtn="重新获取验证码";
                this.disabledBtn=false;
              }
            }, 1000);
        this.disabledBtn=true;
      },
      findVerifyCode(){
//        var regEmail=new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        var regEmail=new RegExp("^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$");
        if (!regEmail.test(this.baseForm.email)) {
          this.$message({
              message: '邮箱格式不正确',
              type: 'error'
          });
          return false;
        }
        if(this.baseForm.email == ''){
          this.$message({
              message: '获取验证码前，请输入邮箱！',
              type: 'error'
          });
          return false;
        }else{

          this.$axios.post('/onelink.mdata.main.api/email/sendVerifyCodeExt?email='+this.baseForm.email, {
          }).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.operateFlag;
            let verifyCode = this.data.verifyCode;
            this.sendEmailFlag  = true;
            this.currentUserId = this.data.userInfo.id;
            if(operateFlag){
              this.$message({
                message: '发送成功',
                type: 'success'
              });
              this.getVerify();
              // this.baseRuleForm.emailVerfyCode = verifyCode;
            }else{
              this.$message({
                message: this.data.errorInfo,
                type: 'error'
              });
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      changeCode(){
        if(this.baseForm.email!='' && !this.sendEmailFlag){
          this.$message({
              message: '请点击"获取验证码"后，再填写邮箱验证码',
              type: 'error'
          });
          return false;
        }
        if(this.baseForm.email !='' && this.baseForm.yzm!=''){
          this.$axios.post('/onelink.mdata.main.api/email/checkVerifyCodeExt?email='+this.baseForm.email+"&code="+this.baseForm.yzm+"&action=changePassword_", {
          }).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.data;
            if(!operateFlag){        
              if(null != Cookies.get('emailCodeFailNumber_changePassword_'+this.baseForm.email.split("@")[0])){
                this.errorCodeFailNumber = Number(Cookies.get('emailCodeFailNumber_changePassword_'+this.baseForm.email.split("@")[0]));
              }else{
                this.errorCodeFailNumber = 0;
              }
              //错误次数大于3次，删除cookie
              if(this.errorCodeFailNumber > 3){
                this.$message({
                  message: '邮箱验证码输入错误超过3次已失效,请重新获取验证码',
                  type: 'error'
                });
              }else{
                this.$message({
                  message: '邮箱验证码输入错误',
                  type: 'error'
                });
              }
              this.checkFlag = false;
            }else{
              this.checkFlag = true;
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/findPassword/verifyIdentity.vue